export const authorizeStateCookieName = `smart-authorize_state`;
export const authorizeUrlCookieName = `smart-authorize_url`;
export const loginStateCookieName = `smart-login_state`;
export const adbContextStateCookieName = `smart-adb_context_state`;
export const adbDemoVehicleCookieName = `smart-adb-demo_vehicle`;
export const adbShowRoomVehicleCookieName = `smart-adb-showroom_vehicle`;
export const cartCookieName = `smart-cart`;
